// src/screens/customer/customerPannel/settings/Settings.jsx

import React, { useContext, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useAuth } from "../../../../context/auth/AuthContext";
// import { showToast } from "../../../../utils/notify";  // ← sirf yeh badla
import {
  User,
  Mail,
  Phone,
  Calendar,
  MapPin,
  Edit2,
  Save,
  X,
  Camera,
} from "lucide-react";
import "../../../../assets/css/customer/customerPannel/settings/Settings.css";
import AppContext from "../../../../context/AppContext";
import axios from "axios";

// ── Read localStorage ONCE before first render so no "Loading…" flash ──
const getInitialCustomer = () => {
  try {
    const raw = localStorage.getItem("loggedInCustomer");
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
};

const Settings = () => {
  const { baseUrl, authToken } = useContext(AppContext);
  const { logout } = useAuth();
  const { loggedInCustomer, setLoggedInCustomer } = useContext(AppContext);
  const [isEditing, setIsEditing] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [notificationPrefs, setNotificationPrefs] = useState({
    emailNotifications: true,
    appNotifications: false,
  });

  const viewAllCustomers = () => {
    console.log("view all customers called!");
    axios.get(`${baseUrl}/customer/auth/viewMyProfile`, {
      headers: {
        Authorization: `Bearer ${authToken}`
      }
    })
      .then((response) => {
        console.log(response.data);
        console.log("TOKEN:", authToken);
        console.log(localStorage.getItem("authToken"));
        if (response.data.success) {
          setLoggedInCustomer(response.data.customer);
        }
      })
      .catch((error) => {
        console.log(error);
        localStorage.removeItem("loggedInCustomer");
        localStorage.removeItem("authToken");

        setLoggedInCustomer(null);

        logout();
      })
  }

  const updateProfileData = () => {
    console.log("edit profile called!");
    const formData = new FormData();
    formData.append("fullName", customer.fullName);
    formData.append("email", customer.email);
    formData.append("phone", customer.phone);
    formData.append("address", customer.address);
    formData.append("birthday", customer.birthday);
    formData.append("gender", customer.gender);
    formData.append("rememberMe", rememberMe);
    axios.post(`${baseUrl}/customer/auth/updateProfileData`, formData, {
      headers: {
        Authorization: `Bearer ${authToken}`
      }
    })
      .then((response) => {
        if (response.data.success && response.data.customer) {
          setLoggedInCustomer(response.data.customer);

          localStorage.setItem(
            "loggedInCustomer",
            JSON.stringify(response.data.customer)
          );
          setIsEditing(false);
        }
      })
      .catch((error) => {
        // console.log(error);
        // setIsEditing(false);
        console.log(error.response.data.message);
      })
  }

  const deleteMyProfile = () => {
    console.log("Delete profile called!");
    axios.post(`${baseUrl}/customer/auth/deleteMyProfile`, {}, {
      headers: {
        Authorization: `Bearer ${authToken}`
      }
    })
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      })
  }


  useEffect(() => {
    viewAllCustomers();
  }, []);


  // Sync AppContext from localStorage on mount (only if context is still null)
  useEffect(() => {
    if (!loggedInCustomer) {
      const data = getInitialCustomer();
      if (data) setLoggedInCustomer(data);
    }
  }, []);

  // ── Use context value OR fall back to localStorage directly ──
  const customer = loggedInCustomer || {};

  // Safe field updater
  const updateField = (field, value) =>
    setLoggedInCustomer({ ...customer, [field]: value });

  // Safe birthday display
  const displayBirthday = () => {
    if (!customer?.birthday) return "—";
    const d = new Date(customer.birthday);
    return isNaN(d)
      ? customer.birthday
      : d.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      });
  };

  const handleSaveProfile = () => {
    localStorage.setItem("loggedInCustomer", JSON.stringify(customer));
    Swal.fire({
      title: "✨ Profile Updated!",
      text: "Your profile has been successfully updated.",
      icon: "success",
      confirmButtonText: "Great!",
      confirmButtonColor: "#D67E43",
      timer: 3000,
    });
    // ← notifyProfileUpdate ki jagah showToast directly
    // showToast({
    //   title: "Profile Updated",
    //   message: "Your profile information has been updated successfully!",
    //   color: "#5C6B47",
    // });
    setIsEditing(false);
  };

  const handleCancelEdit = () => {
    const saved = getInitialCustomer();
    if (saved) setLoggedInCustomer(saved);
    setIsEditing(false);
  };

  const handleDeleteAccount = () => {
    Swal.fire({
      title: "🚨 Delete Account?",
      html: `<div style="text-align:left;padding:14px;"><p style="color:#6B4C3B;margin-bottom:10px;">This action is <strong style="color:#ef4444;">PERMANENT</strong>.</p><ul style="color:#6B4C3B;margin-bottom:10px;padding-left:16px;"><li>All orders deleted</li><li>Wishlist removed</li><li>All data erased</li></ul><p style="color:#ef4444;font-weight:600;">Type <strong>"DELETE"</strong> to confirm</p></div>`,
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: "#ef4444",
      cancelButtonColor: "#6B4C3B",
      confirmButtonText: "Delete Forever",
      cancelButtonText: "Cancel",
      input: "text",
      inputPlaceholder: "Type DELETE to confirm",
      inputValidator: (v) =>
        v !== "DELETE" ? "Please type DELETE in capital letters" : undefined,
    }).then((r) => {
      if (r.isConfirmed) {
        deleteMyProfile();

        Swal.fire({
          title: "Account Deleted",
          text: "Your account has been deleted successfully.",
          icon: "success",
          confirmButtonColor: "#D67E43",
        }).then(() => {
          logout();
        });
      }
    });
  };

  const [errors, setErrors] = useState();
  const { RegExpChecker } = useContext(AppContext);

  return (
    <div className="set-page">
      {/* ── PROFILE CARD ── */}
      <div className="set-profile-card">
        <div className="set-profile-header">
          <div className="set-profile-cover" />

          <div className="set-profile-avatar-section">
            <div className="set-profile-avatar">
              <span className="set-avatar-letter">
                {customer?.fullName?.charAt(0)?.toUpperCase() || "C"}
              </span>
              {isEditing && (
                <button className="set-avatar-edit-btn" type="button">
                  <Camera size={14} />
                </button>
              )}
            </div>

            <div className="set-profile-info">
              {!isEditing ? (
                <>
                  <h1 className="set-profile-name">
                    {customer?.fullName || "Customer"}
                  </h1>
                  <span className="set-profile-role">Premium Customer</span>
                </>
              ) : (
                <input
                  type="text"
                  className="set-profile-name-edit"
                  value={customer?.fullName || ""}
                  onChange={(e) => {
                    updateField("fullName", e.target.value);
                    setErrors(RegExpChecker("fullName", e.target.value));
                  }}
                  placeholder="Full Name"
                />
              )}
            </div>

            <div className="set-profile-actions">
              {!isEditing ? (
                <button
                  className="set-edit-btn"
                  onClick={() => setIsEditing(true)}
                >
                  <Edit2 size={15} />
                  <span>Edit Profile</span>
                </button>
              ) : (
                <>
                  <button className="set-cancel-btn" onClick={handleCancelEdit}>
                    <X size={15} />
                    <span>Cancel</span>
                  </button>
                  <button className="set-save-btn" onClick={updateProfileData}>
                    <Save size={15} />
                    <span>Save</span>
                  </button>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="set-profile-details">
          <div className="set-detail-row">
            <DetailItem
              icon={<Mail size={18} strokeWidth={1.8} />}
              label="Email Address"
              value={customer?.email}
              field="email"
              type="email"
              isEditing={isEditing}
              updateField={updateField}
            />
            <DetailItem
              icon={<Phone size={18} strokeWidth={1.8} />}
              label="Phone Number"
              value={customer?.phone}
              field="phone"
              type="tel"
              isEditing={isEditing}
              updateField={updateField}
            />
          </div>
          <div className="set-detail-row">
            <div className="set-detail-item">
              <div className="set-detail-icon">
                <Calendar size={18} strokeWidth={1.8} />
              </div>
              <div className="set-detail-content">
                <label className="set-detail-label">Birthday</label>
                {!isEditing ? (
                  <p className="set-detail-value">{displayBirthday()}</p>
                ) : (
                  <input
                    type="date"
                    className="set-detail-input"
                    value={customer?.birthday || ""}
                    onChange={(e) => updateField("birthday", e.target.value)}
                  />
                )}
              </div>
            </div>
            <div className="set-detail-item">
              <div className="set-detail-icon">
                <User size={18} strokeWidth={1.8} />
              </div>
              <div className="set-detail-content">
                <label className="set-detail-label">Gender</label>
                {!isEditing ? (
                  <p className="set-detail-value">
                    {customer?.gender
                      ? customer.gender.charAt(0).toUpperCase() +
                      customer.gender.slice(1)
                      : "—"}
                  </p>
                ) : (
                  <select
                    className="set-detail-select"
                    value={customer?.gender || ""}
                    onChange={(e) => updateField("gender", e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                )}
              </div>
            </div>
          </div>
          <div className="set-detail-row">
            <div className="set-detail-item set-detail-item-full">
              <div className="set-detail-icon">
                <MapPin size={18} strokeWidth={1.8} />
              </div>
              <div className="set-detail-content">
                <label className="set-detail-label">Location</label>
                {!isEditing ? (
                  <p className="set-detail-value">{customer?.address || "—"}</p>
                ) : (
                  <input
                    type="text"
                    className="set-detail-input"
                    value={customer?.address || ""}
                    onChange={(e) => updateField("address", e.target.value)}
                    placeholder="City, Country"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── NOTIFICATIONS ── */}

      {/* ── DANGER ZONE ── */}
      <div className="set-danger-card">
        <div className="set-card-header">
          <div className="set-card-header-icon">⚠️</div>
          <div>
            <h2 className="set-card-title">Account Management</h2>
            <p className="set-card-subtitle">Manage your account settings</p>
          </div>
        </div>
        <div className="set-danger-list">
          <div className="set-danger-item">
            <div className="set-danger-info">
              <h3 className="set-danger-title">Delete Account</h3>
              <p className="set-danger-desc">
                Permanently delete your account and all data
              </p>
            </div>
            <button className="set-delete-btn" onClick={handleDeleteAccount}>
              Delete Account
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// ── Small reusable detail item ──
const DetailItem = ({
  icon,
  label,
  value,
  field,
  type,
  isEditing,
  updateField,
}) => (
  <div className="set-detail-item">
    <div className="set-detail-icon">{icon}</div>
    <div className="set-detail-content">
      <label className="set-detail-label">{label}</label>
      {!isEditing ? (
        <p className="set-detail-value">{value || "—"}</p>
      ) : (
        <input
          type={type}
          className="set-detail-input"
          value={value || ""}
          onChange={(e) => updateField(field, e.target.value)}
        />
      )}
    </div>
  </div>
);

export default Settings;